(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = this.header.closest('.header-wrapper');
      this.logoArea = this.header.querySelector('.header__heading');
      this.navigation = this.header.querySelector('.header__inline-menu, .header__menu');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.viewportHeight = window.innerHeight;
      this.scrollThreshold = this.viewportHeight * 0.5; // 50% of viewport

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', () => {
        this.viewportHeight = window.innerHeight;
        this.scrollThreshold = this.viewportHeight * 0.5;
      });

      // Don't make header sticky by default
      this.header.classList.remove('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Only show header when scrolling up AND scroll position > 50% viewport
      const isScrollingUp = scrollTop < this.currentScrollTop;
      const isPastThreshold = scrollTop > this.scrollThreshold;

      if (isScrollingUp && isPastThreshold) {
        // Scrolling up and past threshold - reveal header in stages
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(() => this.revealStaged());
        }
      } else if (scrollTop > this.currentScrollTop) {
        // Scrolling down - hide header
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop <= this.scrollThreshold) {
        // At top of page - reset header
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('header-show-logo', 'header-show-nav');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    revealStaged() {
      if (this.headerIsAlwaysSticky) return;
      
      // Stage 1: Show logo area first
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'header-show-logo');
      this.header.classList.remove('shopify-section-header-hidden');
      
      // Stage 2: Show navigation after a short delay
      setTimeout(() => {
        if (this.header.classList.contains('header-show-logo')) {
          this.header.classList.add('header-show-nav');
        }
      }, 200);
    }

    reveal() {
      // Legacy method - use revealStaged instead
      this.revealStaged();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'header-show-logo', 'header-show-nav');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
